import axios from 'axios';

export interface DataTransferImportResponse {
  dataSet: string;
  summary: { created: number; updated: number; skipped: number; errors: number; total: number };
  details: {
    createdNames: string[];
    updatedNames: string[];
    errorDetails: Array<{ row: number; identifier: string; message: string }>;
  };
}

export interface DataTransferEntity {
  key: string;
  module: string;
  label: string;
}

const authHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const BASE = '/api/v1/data-transfer';

export const dataTransferService = {
  async listEntities(): Promise<DataTransferEntity[]> {
    const { data } = await axios.get(`${BASE}/entities`, { headers: authHeaders() });
    return data;
  },

  async downloadTemplate(entity: string): Promise<string> {
    const { data } = await axios.get(`${BASE}/${entity}/template`, {
      headers: authHeaders(),
      responseType: 'text',
    });
    return data as string;
  },

  async exportData(entity: string): Promise<string> {
    const { data } = await axios.get(`${BASE}/${entity}/export`, {
      headers: authHeaders(),
      responseType: 'text',
    });
    return data as string;
  },

  async importData(entity: string, file: File): Promise<DataTransferImportResponse> {
    const form = new FormData();
    form.append('file', file);
    const { data } = await axios.post(`${BASE}/${entity}/import`, form, {
      headers: { ...authHeaders(), 'Content-Type': 'multipart/form-data' },
    });
    return data;
  },
};
